import { useDispatch, useSelector } from 'react-redux'
import { TableContent } from './TableContent'
import './i18n'
import classes from './index.module.scss'
import { useEffect } from 'react'
import { getListOrdersThunk } from './store/thunk'
import { Filter } from './filter'
import { selectFilterByKey } from './store/slice'
import { ALL_STATUS } from './constants'
import { Header } from './Header'

export const Content = () => {
  const dispatch = useDispatch()

  const orderStatusActive = useSelector(selectFilterByKey('orderStatusActive'))
  const transactionStatusActive = useSelector(
    selectFilterByKey('transactionStatusActive'),
  )
  const page = useSelector(selectFilterByKey('page'))
  const pageSize = useSelector(selectFilterByKey('pageSize'))
  const from = useSelector(selectFilterByKey('from'))
  const to = useSelector(selectFilterByKey('to'))

  useEffect(() => {
    dispatch(
      getListOrdersThunk({
        Page: page,
        PageSize: pageSize,
        OrderStatus:
          orderStatusActive.value !== ALL_STATUS.value
            ? orderStatusActive.value
            : undefined,
        TransactionStatus:
          transactionStatusActive.value !== ALL_STATUS.value
            ? transactionStatusActive.value
            : undefined,
        CreateDateFrom: from,
        CreateDateTo: to,
      }),
    )
  }, [
    orderStatusActive.value,
    transactionStatusActive.value,
    page,
    pageSize,
    from,
    to,
  ])

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.filter}>
        <Filter />
      </div>
      <TableContent />
    </div>
  )
}
